import { compose, branch, renderNothing } from 'recompose'
import { connect } from 'react-redux'
import {
  selectModalMethod,
  selectPricePoint
} from 'src/store/selectors/affordability'
import { PRICEPOINT } from 'src/constants/affordability'
import { setPricePoint } from 'src/actions/affordability'

const CustomPricePointTabContainer = compose(
  connect(
    state => ({
      show: selectModalMethod(state) === PRICEPOINT,
      value: selectPricePoint(state)
    }),
    dispatch => ({
      onChange: e => dispatch(setPricePoint(e.target.value))
    })
  ),
  branch(({ show }) => !show, renderNothing)
)

export default CustomPricePointTabContainer
